// The alt's own cost over baseline in a repeat year: the strategy's total economic
// cost minus the same strategy scored with the alt at zero. The "Pay the tax, or put
// it to work" doors use it for the five-years-running ladder on screen. One engine call per strategy that carries an alt on top of another lever;
// a baseline-plus-alt strategy needs none, since its without-alt run IS the baseline.

import type { TaxScenario, TaxScenarioInput, TaxResults } from "@/tax/types";
import { isBaselinePlusAlt } from "@/lib/comparisonStory";

export type RepeatCosts = Record<string, number>;

export function hasAlt(s: TaxScenario, baseScenario: TaxScenario): boolean {
  return s.id !== baseScenario.id && s.input.alternativeInvestmentAmount > 0;
}

export async function repeatCostsFor(
  scenarios: TaxScenario[],
  baseScenario: TaxScenario,
  compute: (input: TaxScenarioInput) => Promise<TaxResults>,
): Promise<RepeatCosts> {
  const next: RepeatCosts = {};
  const pending: Promise<void>[] = [];
  for (const s of scenarios) {
    if (!hasAlt(s, baseScenario)) continue;
    if (isBaselinePlusAlt(s, baseScenario)) {
      next[s.id] = s.results.totalEconomicCost - baseScenario.results.totalEconomicCost;
      continue;
    }
    pending.push(
      compute({ ...s.input, alternativeInvestmentAmount: 0 })
        .then((without) => {
          if (typeof without?.totalEconomicCost === "number") next[s.id] = s.results.totalEconomicCost - without.totalEconomicCost;
        })
        .catch(() => {}),
    );
  }
  await Promise.all(pending);
  return next;
}
